import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Table, Button, Badge, Stack } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import DeviceService, { DeviceItem } from '#/services/DeviceService';
import { Pagenate, PagenateData } from './parts/Pagenate';
import * as URI from 'urijs';
import { SpinnerView } from './parts/SpinnerView';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { UserContext } from './App';
import { PAGE_SIZE } from '#/config/constant';
import { FilterView } from './parts/FilterView';

dayjs.extend(utc);
dayjs.extend(timezone);

function Child() {
  const ctx = useContext(UserContext);
  const service = new DeviceService('child', ctx.userInfo!);
  const [devices, setDevices] = useState<DeviceItem[]>();
  const uri = new URI.default(window.location.href);
  const [page, setPage] = useState<PagenateData>({
    total: 0,
    page: Number(uri.query(true)['page'] || 0),
    size: PAGE_SIZE,
  });
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setDevices(undefined);

    service
      .getList({
        ...page,
        ...uri.query(true),
      })
      .then(
        (res) => {
          setPage({
            ...page,
            ...res.page,
          });
          setDevices(res.data);
        },
        (e) => {
          if (e?.response.status === 401) {
            navigate(0);
          }
        }
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  let items = [<></>];
  if (devices === undefined) {
    items = [
      <tr key="spinner">
        <td colSpan={8}>
          <SpinnerView />
        </td>
      </tr>,
    ];
  } else if (devices.length > 0) {
    items = devices.map((data: DeviceItem) => {
      const notify = [
        data.notify.sms_verifier ? 'SMS' : '',
        data.notify.email_verifier ? 'Mail' : '',
      ];

      let status = <></>;
      if( data.sensor && Object.keys(data.sensor).length > 0 ) {
        status = (
          <Stack gap={2}>
            <Badge>電圧：{data.sensor!.volt}</Badge>
            <Badge>バッテリー：{data.sensor!.battery}</Badge>
          </Stack>
        );
      }

      return (
        <tr key={`child-${data.id}-tr`}>
          <td>
            <Link key={`child-${data.id}`} to={`/child/${data.id}`}>
              {data.id}
            </Link>
          </td>
          <td>{data.device_id}</td>
          <td>
            {ctx.userInfo!.role === 'user' ? (
              data.owner_id
            ) : (
              <Link
                key={`child-${data.id}-owner-${data.owner_id}`}
                to={`/owner/${data.owner_id}`}
              >
                {data.owner_id}
              </Link>
            )}
          </td>
          <td>{dayjs.tz(data.created_at).format('YYYY-MM-DD HH:mm:ss')}</td>
          <td>{data.sensor?.receive_at ? dayjs.tz(data.sensor.receive_at).format('YYYY-MM-DD HH:mm:ss') : ''}</td>
          <td>
            <Link
              key={`child-${data.id}-admin-${data.admin_id}`}
              to={`/admin/${data.admin_id}`}
            >
              {data.admin_id}
            </Link>
          </td>
          <td>{dayjs.tz(data.updated_at).format('YYYY-MM-DD HH:mm:ss')}</td>
          <td>{status}</td>
          <td>{notify.join(' / ')}</td>
        </tr>
      );
    });
  } else {
    items = [
      <tr key="no-data">
        <td colSpan={8}>データがありません</td>
      </tr>,
    ];
  }

  const addButton =
    ctx.userInfo && ctx.userInfo.role !== 'user' ? (
      <Button variant="primary" href="/child/modify" className="w-50">
        登録
      </Button>
    ) : (
      <></>
    );

  return (
    <>
      <header className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
        <div className="container-xl px-4">
          <div className="page-header-content pt-1">
            <div className="row align-items-center justify-content-between">
            </div>
          </div>
        </div>
      </header>
      <div className="container-xl px-4 mt-n10">
        <div className="card mb-4">
          <div className="card-body">
            <Row>
              <Col>
                <FilterView
                  id={true}
                  device_id={true}
                  admin_id={
                    ctx.userInfo && ctx.userInfo!.role === 'superuser' ? true : false
                  }
                  owner_id={true}
                  date_range={'設置日'}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <Pagenate {...page} />
              </Col>
              <Col className="text-end">{addButton}</Col>
            </Row>
            <Row className="mt-3 border">
              <Col className="p-2">
                <Table className="mb-0">
                  <thead>
                    <tr>
                      <th>子機ID</th>
                      <th>識別ID</th>
                      <th>親機ID</th>
                      <th>設置日</th>
                      <th>管理者</th>
                      <th>最終更新日</th>
                      <th>最新センサー更新日</th>
                      <th>最新ステータス</th>
                      <th>お知らせ設定</th>
                    </tr>
                  </thead>
                  <tbody>{items}</tbody>
                </Table>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
}

export default Child;
